import client from '@common/utils/rest';

export const getPedigreeFolders = () => {
	return client({
    path: 'api/pedigree/loadPedigreeFolders',
    method: 'GET',
		params: {
      addPedCheck: true,
    },
  }).then((response) => {
    return response.entity;
  });
};

export const checkPedigreeNameExists = (folderId, pedigreeName) => {
	return client({
    path: 'api/pedigree/checkPedigreeNameExists',
    method: 'GET',
		params: {
      folderId,
      pedigreeName,
    },
  }).then((response) => {
    return response.entity;
  });
};

export const createPedigreeAndMoveToFolder = ({ pedigreeName, pedigreeFolderId, familyId }) => {
	return client({
    path: 'api/individuals/createPedigreeAndMoveToFolder',
    method: 'POST',
		entity: {
      pedigreeFolderId,
      pedigreeName,
      familyId,
    },
  }).then((response) => {
    return response.entity;
  });
};